import { Component, Input, OnInit, Output } from '@angular/core';
import { PaginationStore } from './pagination.store';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  providers:[ PaginationStore ]
})
export class PaginationComponent implements OnInit {

  vm$ = this.store.vm$

  @Input() set items(items: number){
    this.store.setItems(items)
  }

  @Input() set valueTracker(value: number){
    this.store.setValue([Number(value), 'external'])
  }

  @Input() set itemsPerPage(itemsPerPage: number){
    this.store.setItemsPerPage(itemsPerPage)
  }

  @Input() set goToPageLabel(goToPageLabel: string){
    this.store.patchState({goToPageLabel})
  }

  @Input() set pageNumberLabel(pageNumberLabel: string){
    this.store.patchState({pageNumberLabel})
  }

  @Input() set goLabel(goLabel: string){
    this.store.patchState({goLabel})
  }

  // @Output() pageChange: EventEmitter<number> = new EventEmitter()
  @Output() pageChange = this.store.eventEmitter$

  constructor(private store: PaginationStore) { }

  ngOnInit(): void {}


  selectPage(page: any) {
    if(typeof page === 'number'){
      this.store.setValue([page, 'internal'])
    }
  }

  changePageByOne(dir: 'next' | 'prev'){
    if(dir === 'next'){
      this.store.nextPage()
    }

    if(dir === 'prev'){
      this.store.prevPage()
    }
  }

  onPaste(event): boolean {
    event.preventDefault();
    return false;
  }

  onSubmit(form: NgForm){
    if(form.value.page){
      this.store.setPage(form.value.page)
    }
    form.reset()
    
  }

}
